/**
 * Ingatlan adatlap komponens modul
 *
 * @author Erik Banhalmi 2017.06.27.
 */
import angular from 'angular';
import vcRecaptcha from 'angular-recaptcha';

import { RealEstateComponent } from './real-estate.component';

import realEstateHandler from './../real-estate-handler.module';
import messagingService from './../../messaging/messaging.module';

import realEstateDataDisplayer from './../real-estate-data-displayer/real-estate-data-displayer';
import realEstateAgent from './../real-estate-agent/real-estate-agent.module';
import dutyCalculator from './../duty-calculator/duty-calculator.module';
import realEstateMap from './../real-estate-map/real-estate-map.module';
import realEstateGallery from './../real-estate-gallery/real-estate-gallery.module';
import realEstatePrices from './../real-estate-prices/real-estate-prices.module';
import realEstateRelated from './../real-estate-related/real-estate-related.module';
import loanCalculatorComponent from '../../loan/loan-calculator/loan-calculator.module';
import loanCalculatorComponent2 from '../../loan/loan-calculator/loan-calculator-2.module';
import realEstateInterest from '../../real-estate/real-estate-interest/real-estate-interest.module';
import WebWalk from './../../webwalk-util/webwalk.module';
import SeoUtil from './../../seo-util/seo-util.module';
import agentLike from './../sticky-agent-like/sticky-agent-like.module';
import login from './../../../frame/header/login/login.module';
import shareEmail  from '../../../application/share-with-copy-link-and-email/share-email.module'

export const realEstateModule = angular
	.module('realEstate', [shareEmail, login, realEstateHandler, messagingService, realEstateDataDisplayer,
		realEstateAgent, dutyCalculator, realEstateMap, realEstateGallery, vcRecaptcha, realEstatePrices, realEstateRelated, loanCalculatorComponent,
		loanCalculatorComponent2, realEstateInterest, WebWalk, SeoUtil, agentLike])
	.component('realEstate', RealEstateComponent)
	.name;
